module.exports = __webpack_public_path__ + "img/attention-circle-duotone.f6bcc12c.svg";